import { AppBar, Box } from '@mui/material';
import React from 'react';
import nooliLogo from 'assets/logos/nooli.svg';
import { Outlet } from 'react-router-dom';
import MainContainer from 'components/mainContainer';
import HeaderSection from 'components/headerSection';
import BurgerMenu from 'components/burgerMenu';
import Snackbar from 'components/snackbar';

import { useNavigate } from 'react-router-dom';
const Layout = () => {
  const navigate = useNavigate();
  const is404 = location.pathname === '/page-not-found';
  return (
    <React.Fragment>
      <AppBar>
        <HeaderSection>
          <img
            src={nooliLogo}
            alt="nooliLogo"
            onClick={() => {
              navigate('/home');
            }}
            style={{ cursor: 'pointer', paddingBottom: '20px' }}
          />
          <Box>
            <BurgerMenu />
          </Box>
        </HeaderSection>
      </AppBar>
      {!is404 ? (
        <MainContainer>
          <Outlet />
        </MainContainer>
      ) : (
        <Outlet />
      )}
      <Snackbar />
    </React.Fragment>
  );
};

export default Layout;
